import { Button } from "../ui";

interface SubscribeStep6Props {
  onNext: () => void;
  onSubmit: () => void;
}

const SubscribeStep6: React.FC<SubscribeStep6Props> = ({ onNext, onSubmit }) => {
  const handleVisitWebsite = () => {
    onSubmit(); // Submit the form first
    window.open('https://www.locanest.app', '_blank');
  };

  return (
    <>
      <h2 className="text-xl font-bold text-left text-gray-900 mb-4">
        Thank you for your interest in LocaNest!
      </h2>
      <p className="text-sm text-gray-900 pb-4">
        We will review your application and get back to you as soon as possible! 
      </p>
      <p className="text-sm text-gray-900 pb-4">
        If you need LocaNest really urgently, please contact us at <a href="mailto:info@locanest.com" className="text-purple-600 hover:text-purple-800 underline">info@locanest.com</a>
      </p>
      
      <div className="flex flex-col gap-3 mt-6">
        <Button
          variant="default"
          onClick={handleVisitWebsite}
          className="w-full bg-purple-600 hover:bg-purple-700"
        >
          Visit www.locanest.app
        </Button>
        
        <Button
          variant="outline"
          onClick={onNext}
          className="w-full"
        >
          Back to Start
        </Button>
      </div>
    </>
  );
};

export default SubscribeStep6;
